import { render, staticRenderFns } from "./Fixtext.vue?vue&type=template&id=25dbcb9a&"
import script from "./Fixtext.vue?vue&type=script&lang=js&"
export * from "./Fixtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports